import P from "../../assets/icons/icon-metamask.svg.js";
import M from "../../assets/icons/icon-okx.svg.js";
import x from "../../assets/icons/icon-ronin.svg.js";
import l from "../../config/index.js";
import { ChainNetworkType as r, CHAIN_CONFIG_MAP as W, ChainEnvironment as G, ChainType as a, ChainAddressType as i } from "../../constants/chain.js";
import { WalletType as e, WalletProviderType as m } from "../../constants/web3.js";
import { useConfigContext as L } from "../../contexts/config/ConfigContext.js";
import { getProvider as b } from "../../util/authenication/index.js";
import { isIosOrAndroid as v, isOkxApp as S } from "../../util/browser/index.js";
import { walletRdnsToType as U } from "../../util/wallet/walletRdnsToType.js";
import { getAccount as Y } from "@wagmi/core";
import * as p from "ramda";
import * as E from "ramda-adjunct";
import { useCallback as o } from "react";
import { useTranslation as V } from "react-i18next";
const ee = () => {
  const {
    t: u
  } = V(), {
    config: f
  } = L(), {
    chainSwitcher: s
  } = f, N = (s == null ? void 0 : s.preferredNetwork) || r.Ronin, w = o(() => W[G.Mainnet], []), T = o((n) => {
    switch (n) {
      case a.Polygon:
      case a.PolygonTestnet:
        return l.URL.TRANSACTION.POLYGON;
      case a.Ronin:
      case a.RoninTestnet:
      default:
        return l.URL.TRANSACTION.RONIN;
    }
  }, []), y = o((n) => {
    var t;
    return (t = w().find((R) => R.chainAddressType === n)) == null ? void 0 : t.chainId;
  }, [w]), c = o(() => {
    const n = p.isNotNil(s) ? Y(s.wagmiConfig) : null;
    if (n != null && n.connector)
      return U(n.connector.id);
    const t = b();
    if (E.isNotNilOrEmpty(t))
      return t;
    switch (N) {
      case r.Polygon:
        return e.Metamask;
      case r.Ronin:
      default:
        return v() && !window.ronin && !S() ? e.RoninMobile : e.Ronin;
    }
  }, [N]), C = o((n) => {
    switch (n) {
      case e.Metamask:
        return u("common.network.polygon");
      case e.Okx:
      case e.Ronin:
      case e.RoninMobile:
      case e.WalletConnect:
      default:
        return u("common.network.ronin");
    }
  }, [u]), O = o((n) => {
    switch (n) {
      case e.Metamask:
        return P;
      case e.Okx:
        return M;
      case e.Ronin:
      case e.RoninMobile:
      case e.WalletConnect:
      default:
        return x;
    }
  }, []), d = o((n) => {
    switch (n) {
      case e.Metamask:
        return window.ethereum;
      case e.Okx:
        return window.okxwallet;
      case e.Ronin:
      case e.RoninMobile:
      case e.WalletConnect:
      default:
        return window.ronin;
    }
  }, []), k = o((n) => {
    switch (n) {
      case e.Metamask:
        return a.Polygon;
      case e.Okx:
      case e.Ronin:
      case e.RoninMobile:
      case e.WalletConnect:
      default:
        return a.Ronin;
    }
  }, []), g = o((n, t = {
    walletType: e.None
  }) => {
    if (p.isNil(n))
      return null;
    switch (t.walletType ? t.walletType : c()) {
      case e.Metamask:
        return n[i.POLYGON];
      case e.Ronin:
      case e.RoninMobile:
      case e.Okx:
      case e.WalletConnect:
      default:
        return n[i.RONIN];
    }
  }, [c]), h = o((n, t = {
    networkType: r.None,
    walletType: e.None
  }) => {
    if (p.isNil(n))
      throw new Error("Address map is not provided");
    switch (t.networkType) {
      case r.Polygon:
        return n[i.POLYGON];
      case r.Ronin:
        return n[i.RONIN];
    }
    switch (t.walletType ? t.walletType : c()) {
      case e.Metamask:
        return n[i.POLYGON];
      case e.Ronin:
      case e.RoninMobile:
      case e.Okx:
      case e.WalletConnect:
      default:
        return n[i.RONIN];
    }
  }, [c]), A = o((n) => {
    switch (n) {
      case e.WalletConnect:
        return m.WalletConnect;
      case e.Metamask:
        return m.Metamask;
      case e.Okx:
        return m.Okx;
      case e.Ronin:
      case e.RoninMobile:
      default:
        return m.Ronin;
    }
  }, []), I = o((n, t) => {
    switch (n) {
      case r.Polygon:
        return `${l.URL.TRANSACTION.POLYGON}${t}`;
      case r.Ronin:
      default:
        return `${l.URL.TRANSACTION.RONIN}${t}`;
    }
  }, []);
  return {
    detectWalletType: c,
    getChainConfigs: w,
    getChainDomain: T,
    getChainIdByType: y,
    getChainName: C,
    getChainImage: O,
    getChainProvider: d,
    getChainType: k,
    getContractAbi: g,
    getContractAddress: h,
    getWalletProvider: A,
    getTransactionUrl: I
  };
};
export {
  ee as default
};
//# sourceMappingURL=useChainSwitcher.js.map
